import { parsePhoneNumberFromString } from 'libphonenumber-js';

const MISSING_PHONE_DISPLAY = '--';

export function formatPhoneForDisplay(
  phone: string | null | undefined,
): string {
  const trimmed = phone?.trim() ?? '';
  if (!trimmed) return MISSING_PHONE_DISPLAY;

  const parsed = parsePhoneNumberFromString(trimmed);
  if (parsed) return parsed.formatInternational();
  return trimmed;
}

export function phoneTelHref(
  phone: string | null | undefined,
): string | null {
  const trimmed = phone?.trim() ?? '';
  if (!trimmed) return null;

  const parsed = parsePhoneNumberFromString(trimmed);
  if (parsed) return `tel:${parsed.number}`;
  return `tel:${trimmed}`;
}
